import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const CustomLinearProgress = ({progress, show=false, modal=false}) => {
    return (
        <Box className={(!show ? "d-none": "") + " linear-progress " + ( modal ? "": "no-modal")}>
            <LinearProgress className={"bar"} variant="determinate" value={progress} />
        </Box>
    );
}

export default CustomLinearProgress;